import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Typography, Icon } from '@telus/koodo-ui-kit'

/**
 * SuccessStep — third and final step of the verify flow.
 *
 * Shown after OTP is verified successfully. Calls onComplete after
 * autoRedirectMs to let VerifyPage handle the actual navigation,
 * keeping this component free of routing concerns.
 */

const SuccessStep = ({
  successFirstLine,
  successSecondLine,
  onComplete,
  autoRedirectMs
}) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, autoRedirectMs)
    return () => clearTimeout(timer)
  }, [onComplete, autoRedirectMs])

  return (
    <div className="flex flex-row items-center justify-center h-96 space-x-4 text-black">
      <Icon icon="CheckCircle" className="icon-104" accessibilityLabel={successSecondLine} />
      <Typography heading="h2" variant={{ size: 'h2' }} block>
        <span className="block">{successFirstLine}</span>
        <span className="block">{successSecondLine}</span>
      </Typography>
    </div>
  )
}

SuccessStep.propTypes = {
  successFirstLine: PropTypes.string,
  successSecondLine: PropTypes.string,
  onComplete: PropTypes.func.isRequired,
  autoRedirectMs: PropTypes.number
}

SuccessStep.defaultProps = {
  successFirstLine: '',
  successSecondLine: '',
  autoRedirectMs: 500
}

export default SuccessStep
